import { Component, Inject, Vue } from 'vue-property-decorator';
import AlertService from '@/shared/alert/alert.service';
import { IBpmUserTask } from '@/shared/model/bpm-user-task.model';
import { BpmTaskState } from '@/shared/model/enumerations/bpm-task-state.model';
import { IBpmUserTaskExtended } from '@/shared/model/bpm-user-task-extended.model';

/**
 * An utility service.
 */
@Component
export default class PostboxUtils extends Vue {
  @Inject('alertService') protected alertService: () => AlertService;

  public getTaskDescriptionPart1(desc: string, lang: string): string {
    desc = desc?.replace('\\n', '\n') ?? '';

    // Strip optional agencyId prefix in the form "<agencyId>§§" only when it is at the very beginning
    // Keep backward compatibility for all other descriptions
    if (desc && desc.startsWith('§§')) {
      // Edge case: malformed (no id before). Just remove leading delimiter.
      desc = desc.substring(2);
    } else if (desc) {
      const delimPos = desc.indexOf('§§');
      if (delimPos > 0) {
        const maybeId = desc.substring(0, delimPos);
        if (/^\d+$/.test(maybeId)) {
          desc = desc.substring(delimPos + 2);
        }
      }
    }

    const newLinePos = desc.indexOf('\n');
    if (newLinePos >= 0) {
      desc = desc.substring(0, newLinePos);
    }
    const semicolonPos = desc.indexOf(';');
    if (semicolonPos >= 0) {
      const addition = desc.substring(semicolonPos + 1);
      return this.$t(desc.substring(0, semicolonPos), lang, { param: addition }).toString();
    }

    return this.$t(desc, lang).toString();
  }

  // Extract optional agencyId prefix from description of form "<agencyId>§§..."
  // Returns a number when present or null otherwise
  public getAgencyIdFromDescription(desc: string): number | null {
    if (!desc) {
      return null;
    }
    const delimPos = desc.indexOf('§§');
    if (delimPos > 0) {
      const maybeId = desc.substring(0, delimPos);
      if (/^\d+$/.test(maybeId)) {
        try {
          return parseInt(maybeId, 10);
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  }

  public getTaskDescriptionPart2(desc: string, lang: string): string {
    desc = desc.replace('\\n', '\n');
    const newLinePos = desc.indexOf('\n');
    if (newLinePos >= 0 && newLinePos + 1 < desc.length) {
      return desc.substring(newLinePos + 1);
    }

    return null;
  }

  public isTaskFinished(task: IBpmUserTask): boolean {
    return BpmTaskState.FINISHED == task.state;
  }

  public isTaskEditable(task: IBpmUserTaskExtended): boolean {
    return task.canEdit == true && task.userTask.state == BpmTaskState.OPEN;
  }

  public isTaskDataEditable(task: IBpmUserTask): boolean {
    return (
      (task.taskType == 'customer-task' || task.taskType == 'carer-task' || task.taskType == 'task-reminder') &&
      task.state == BpmTaskState.OPEN
    );
  }
}
